"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignDraftsResponseToJSON = exports.CampaignDraftsResponseFromJSONTyped = exports.CampaignDraftsResponseFromJSON = exports.instanceOfCampaignDraftsResponse = void 0;
var runtime_1 = require("../runtime");
var CampaignDraft1_1 = require("./CampaignDraft1");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the CampaignDraftsResponse interface.
 */
function instanceOfCampaignDraftsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignDraftsResponse = instanceOfCampaignDraftsResponse;
function CampaignDraftsResponseFromJSON(json) {
    return CampaignDraftsResponseFromJSONTyped(json, false);
}
exports.CampaignDraftsResponseFromJSON = CampaignDraftsResponseFromJSON;
function CampaignDraftsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'drafts': !(0, runtime_1.exists)(json, 'drafts') ? undefined : (json['drafts'].map(CampaignDraft1_1.CampaignDraft1FromJSON)),
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
    };
}
exports.CampaignDraftsResponseFromJSONTyped = CampaignDraftsResponseFromJSONTyped;
function CampaignDraftsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'drafts': value.drafts === undefined ? undefined : (value.drafts.map(CampaignDraft1_1.CampaignDraft1ToJSON)),
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
    };
}
exports.CampaignDraftsResponseToJSON = CampaignDraftsResponseToJSON;
